import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row, Collapse} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronCircleDown, faChevronCircleUp} from '@fortawesome/pro-light-svg-icons';
import {faCirclePlus} from '@fortawesome/pro-light-svg-icons/faCirclePlus';
import {faCircleMinus} from '@fortawesome/pro-light-svg-icons/faCircleMinus';
import classNames from 'classnames';
import {faq, evergreenFaq} from 'data/faq.json';
import './FaqList.scss';

const remarkSubSuper = require('remark-sub-super');

export default function FaqList({
  faqlist = faq,
  clarityCall = false,
  phaseIteration,
  masterclassOverride = false,
  borderColor = 'black-15',
  slice = 0,
  ...props
}) {
  const [activeCards, setActiveCards] = React.useState([]);
  const onClick = React.useCallback(
    (key) => () => setActiveCards((state) => (state.includes(key) ? state.filter((e) => e !== key) : [...state, key])),
    []
  );

  const insider = phaseIteration === 'insiderPromo';
  const lateApp = phaseIteration === 'lateApp';

  return faqlist.slice(slice).map((faq, index) => {
    if (
      (insider && faq.id === 'appDeadlineLate') ||
      (insider && faq.id === 'appDeadline') ||
      (insider && faq.id === 'directory') ||
      (insider && faq.id === 'refundPolicy') ||
      (!insider && faq.id === 'refundPolicyInsider') ||
      (lateApp && faq.id === 'appDeadline') ||
      (lateApp && faq.id === 'appDeadlineInsider') ||
      (!lateApp && !insider && faq.id === 'appDeadlineInsider') ||
      (!lateApp && !insider && faq.id === 'appDeadlineLate') ||
      (!clarityCall && faq.id === 'questionsAnsweredClarityCall') ||
      (clarityCall && faq.id === 'questionsAnswered')
    ) {
      return null;
    }
    return (
      <div className={classNames(`faq-item faq-item-border-${borderColor}`)} key={index}>
        <div className="faq-item-header d-flex align-items-center justify-content-between" onClick={onClick(index)}>
          <div className="faq-item-header-text">
            <ReactMarkdown className="faq-item-header-title" source={faq.question || 'faq question'} />
          </div>
          <div className="faq-item-header-icon d-flex align-items-center justify-content-end flex-column flex-lg-row">
            <FontAwesomeIcon
              className="faq-item-icon mb-1 mb-lg-0 mr-lg-1"
              icon={activeCards.includes(index) ? faChevronCircleUp : faChevronCircleDown}
            />
            <div className="faq-item-header-icon-text text-small text-uppercase">
              {activeCards.includes(index) ? (
                <>Close</>
              ) : (
                <>
                  <span className="d-none d-lg-inline">Learn</span> More
                </>
              )}
            </div>
          </div>
        </div>
        <Collapse isOpen={activeCards.includes(index)}>
          <div className="faq-item-content">
            <ReactMarkdown
              source={faq.answer || 'faq answer'}
              plugins={[remarkSubSuper]}
              renderers={{
                sub: 'sub',
                sup: 'sup'
              }}
            />
          </div>
        </Collapse>
      </div>
    );
  });
}

export function EvergreenFaqList({id, question, answer, ...props}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = () => setIsOpen(!isOpen);
  return (
    <div
      id={`faq-${id}`}
      key={`faq-${id}`}
      className={classNames('evergreenFaq-item', `rounded`, `box-shadow-black-50`)}
    >
      <div
        className={classNames(
          `evergreenFaq-item-header`,
          `d-flex`,
          `align-items-center`,
          `justify-content-between`,
          isOpen ? `rounded-top open` : `rounded`
        )}
        onClick={toggleIsOpen}
      >
        <ReactMarkdown className={classNames(`evergreenFaq-item-question`)}>{question}</ReactMarkdown>
        <div className={classNames('icon-wrap', `d-flex`, `align-items-center`, `justify-content-end`, `flex-column`)}>
          <FontAwesomeIcon className={classNames('icon-svg', `mb-2`)} icon={isOpen ? faCircleMinus : faCirclePlus} />
          <div className={classNames('icon-text', `text-small`, `text-uppercase`)}>
            {isOpen ? <>Close</> : <>More</>}
          </div>
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <Row>
          <Col xs={12}>
            <div className={classNames(`evergreenFaq-item-content`, `rounded-bottom`)}>
              <ReactMarkdown className={classNames(`evergreenFaq-item-answer`)}>{answer}</ReactMarkdown>
            </div>
          </Col>
        </Row>
      </Collapse>
    </div>
  );
}
